<div class="filter-date-time">
  <div
    class="filter-date-time__input-group vox-input-group vox-input-group_dense"
    (clickOutside)="closePopover()">
    <div
      class="filter-date-time__input-opening"
      (click)="togglePopover()">
      <input
        type="text"
        readonly
        placement="bottom"
        [value]="uiDate"
        class="filter-date-time__input vox-text-field" />
      <i class="filter-date-time__input-icon icon-small-calendar"></i>
    </div>
    <div
      class="filter-date-time__popover"
      *ngIf="popoverOpen">
      <div class="filter-date-time__modal">
        <app-filter-date
          (changeDate)="onChangeDate($event)"
          [maxDate]="_maxDateNgb"
          [minDate]="_minDateNgb"
          [date]="date"></app-filter-date>
        <hr />
        <app-filter-time
          (changeTime)="onChangeTime($event)"
          [time]="time"
          [maxTime]="_maxDate"
          [minTime]="_minDate"></app-filter-time>
      </div>
    </div>
  </div>
</div>
